var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPriorityIcon = function SvgPriorityIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "entire-frame"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "icon",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#entire-frame)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "icon",
    cx: 13.5,
    cy: 13.5,
    r: 11,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    transform: "translate(-4.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "background",
    d: "M19.559,11.977 C19.421,13.073 18.413,18.184 18.081,19.933 C18.02,20.259 17.738,20.439 17.406,20.439 L17.395,20.439 C17.052,20.439 16.764,20.248 16.698,19.916 C16.36,18.14 15.353,12.997 15.22,11.917 C15.059,10.622 16.072,9.484 17.378,9.484 C18.701,9.49 19.725,10.665 19.559,11.977 M17.417,25.277 C16.52,25.277 15.795,24.552 15.795,23.655 C15.795,22.759 16.52,22.034 17.417,22.034 C18.314,22.034 19.039,22.759 19.039,23.655 C19.039,24.552 18.314,25.277 17.417,25.277 M17.389,4 C9.992,4 4,9.993 4,17.39 C4,24.787 9.992,30.78 17.389,30.78 C24.786,30.78 30.779,24.787 30.779,17.39 C30.779,9.993 24.786,4 17.389,4"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPriorityIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/priority-icon.14ebb5764dcc482bf83a7b67c3fa80f4.svg";